<template>
    <section class="w-screen h-screen absolute flex justify-center items-center z-50">
        <div id="modal modal-customer"
            class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white shadow-md rounded-lg" :class="{
                'animate__animated animate__zoomIn': showModal,
                'animate__animated animate__zoomOut': !showModal,
            }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Filter</h5>
            </div>
            <div id="modal-body" class="p-5">
                <InputSelect v-model="selectedUserId" label="User" id="filter-user" :options="allUsers"
                    placeholder="Pilih user" optionLabel="name" optionValue="id" />
                <InputSelect v-model="selectedRoleId" label="Role" id="filter-role" :options="allRoles"
                    placeholder="Pilih role" optionLabel="name" optionValue="id" />
                <InputSelect v-model="selectedPermissionId" label="Permission" id="filter-permission"
                    :options="allPermissions" placeholder="Pilih permission" optionLabel="name" optionValue="id" />
                <InputSelect v-model="selectedMethodId" label="Method" id="filter-method" :options="optionMethods"
                    placeholder="Pilih method" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Filter"
                        button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitFilter" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import SubmitButton from '@/components/form/SubmitButton.vue';
import { mapGetters } from 'vuex';
import InputSelect from '@/components/form/InputSelect.vue';
import { formatTime } from '@/helpers/formatTime';

export default {
    name: "FilterActivity",
    props: {
        filter: {
            type: Object,
            default: null,
        }
    },
    components: {
        SubmitButton, InputSelect
    },
    computed: {
        ...mapGetters('users', ['allUsers']),
        ...mapGetters('roles', ['allRoles']),
        ...mapGetters('permissions', ['allPermissions']),
        optionUsers() {
            return this.allUsers.map((item) => {
                return {
                    name: `${formatTime(item.time_start)} - ${formatTime(item.time_end)}`,
                    id: item.id
                }
            })
        },
        optionRoles() {
            return this.allRoles.map((item) => {
                return {
                    name: `${formatTime(item.time_start)} - ${formatTime(item.time_end)}`,
                    id: item.id
                }
            })
        },
        optionPermissions() {
            return this.allPermissions.map((item) => {
                return {
                    name: `${formatTime(item.time_start)} - ${formatTime(item.time_end)}`,
                    id: item.id
                }
            })
        },
        optionMethods() {
            return [
                {label: 'GET', value: 'GET'},
                {label: 'POST', value: 'POST'},
                {label: 'PUT', value: 'PUT'},
                {label: 'DELETE', value: 'DELETE'},
            ]
        }
    },
    async created() {
        try {
            // Fetch required data in parallel
            await Promise.all([
                this.$store.dispatch("users/fetchUsers", { limit: 1000 }),
                this.$store.dispatch("roles/fetchRoles", { limit: 1000 }),
                this.$store.dispatch("permissions/fetchPermissions", { limit: 1000 }),
            ]);
            this.isLoading = false;
        } catch (error) {
            console.log(error);
            this.errorMessage =
                error.message ||
                "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
            this.showErrorDialog = true;
            this.isLoading = false;
        }
    },
    data() {
        return {
            showModal: true,
            selectedUserId: '',
            selectedRoleId: '',
            selectedPermissionId: '',
        }
    },
    methods: {
        formatTime,
        closeModal() {
            this.showModal = false;
            setTimeout(() => {
                this.$emit('closeModal');
            }, 200);
        },
        submitFilter() {
            this.$emit('submitFilter', {
                user_id: this.selectedUserId,
                role_id: this.selectedRoleId,
                permission_id: this.selectedPermissionId,
                method: this.selectedMethodId,
            });
            this.closeModal();
        }
    }
}
</script>